import {
  ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  Line, ResponsiveContainer,
} from 'recharts';

export default function AttLineChart({ data = [] }) {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <div style={{ textAlign: 'center' }}>Broj izostanaka tokom godine</div>
      <ResponsiveContainer>
        <ComposedChart
          width={350} height={200} data={data}
          margin={{ top: 20, right: 20, bottom: 40, left: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="datum" />
          <YAxis />
          <Legend />
          <Tooltip />
          <Line type="monotone" dataKey="opravdani" stroke="#00b7a8" />
          <Line type="monotone" dataKey="neopravdani" stroke="#ff7300" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
